import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  fullWidth = false,
  children,
  className = '',
  ...props 
}) => {
  const baseStyles = 'px-5 py-2.5 rounded-xl font-semibold transition-all disabled:opacity-50 inline-flex items-center justify-center';
  const variantStyles = {
    primary: 'bg-primary text-white hover:bg-opacity-90 shadow-sm',
    secondary: 'bg-gray-100 text-gray-800 hover:bg-gray-200',
    outline: 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 hover:text-gray-900 shadow-sm'
  };
  const widthStyles = fullWidth ? 'w-full' : '';

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${widthStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};